const modelDataRequest = {
    id:0,
    id_form_temp: 0,
    table_name: "",
    id_workflow_status: 0,
    request_no: "",
    request_date: "",
    contract_no : "",
    id_business_unit : "",
    business_unit_other : "",
    id_confidential_level : 0,
    counterparty_name : "",
    request_by: "",
    require_handled_by: "",
    approve_request_by: "",
    accept_request_by : "",
    is_user_final_doc: "",
    final_doc: "",
    memo_doc: "",
    agreement_doc: "",
    select_user_approve_by: "",
    user1_approve_by: "",
    user2_approve_by: "",
    user3_approve_by: "",
    select_legal_approve_by: "",
    legal1_approve_by: "",
    legal2_approve_by: "",
    legal3_approve_by: "",
    signed_doc: "",
    status: "1",
};

const modelRequestWorkFlow = {
    id: 0,
    id_request: 0,
    id_workflow_status: 0,
    do_by: "",
    send_to: "",
    cc_to: "",
    comment: "",
    document: "",
    do_date: "",
    finish_date: "",
    consent: "",
    status: "1",
};

const modelSendMail = {
    id_request: 0,
    id_workflow_status: 0,
    name_requestor: "",
    email_requestor: "",
    name_approval: "",
    email_approval: "",
    name_legal: "",
    email_legal: "",
};

const modelFormCsa = {
    id: 0,
    id_request:"",
    project_name: "", // csa
    draft_agreement:"", // csa
    draft_doc:"",
    id_business_unit:"",
    business_unit_other:"",
    business_unit_act_as:"",
    counterparty_name:"",
    counterparty_doc:"",
    counterparty_act_as:"",
    purpose:"",
    place_of_work:"",
    scope_of_work:"",
    scope_of_work_doc:"",
    is_sla:"",
    is_sla_doc:"",
    consider_doc:"",
    term_start_date:"",
    term_end_date:"",
    term_other:"",
    term_renewal_condition:"",
    service_fee_total:"",
    vat:"",
    service_fee_payment_type:"",
    service_fee_payment_detail:"",
    service_fee_credit_term:"",
    performance_bond:"",
    penalty_delay_service:"",
    penalty_not_delivered:"",
    penalty_absence_work:"",
    penalty_others:"",
    termination_detail:"",
    ip_ownership_detail:"",
    warranty:"",
    stamp_duty:"",
    other_fee:"",
    other_conditions:"",
    id_language:"", //int
    id_confidential_level:"", //int
    share_pdpa:"",
    user_comment:"",
    require_handled_by: "",
    approve_request_by: "",
    create_request_by: "", // it's mean coordinator_request_by
    approver_comment: "",
}

const modelFormNda = {
    id: 0,
    id_request: "",
    id_language: "",
    id_confidential_level: "",
    project_name: "",
    is_have_draft: "",
    draft_doc: "",
    counterparty_name: "",
    id_business_unit: "",
    business_unit_other: "",
    type_of_nda: "",
    purpose: "",
    beginning_date: "",
    share_pdpa: "",
    user_comment: "",
    approve_request_by: "",
    approver_comment: "",
    require_support_docs: "",
    require_support_doc_other: "",
    consider_doc: "",
    require_handled_by: "",
}

const modelFormLdr = {
    id: 0,
    id_request: 0,
    id_request_type: 0,
    id_sub_request_type: 0,
    id_sub_division_request_type: 0,
    name_th_request_type: "",
    name_en_request_type: "",
    name_th_sub_request_type: "",
    name_en_sub_request_type: "",
    name_th_division_sub_request_type: "",
    name_en_division_sub_request_type: "",
    id_business_unit: 0,
    business_unit_other: "",
    req_doc_cert: "",
    doc_cert_bu_1: 0,
    name_doc_cert_bu_1: "",
    doc_cert_bu_other_1: "",
    doc_cert_bu_expire_1: "",
    doc_cert_amount_1: 0,
    doc_cert_bu_2: 0,
    name_doc_cert_bu_2: "",
    doc_cert_bu_other_2: "",
    doc_cert_bu_expire_2: "",
    doc_cert_amount_2: 0,
    doc_cert_bu_3: 0,
    name_doc_cert_bu_3: "",
    doc_cert_bu_other_3: "",
    doc_cert_bu_expire_3: "",
    doc_cert_amount_3: 0,
    doc_cert_bu_4: 0,
    name_doc_cert_bu_4: "",
    doc_cert_bu_other_4: "",
    doc_cert_bu_expire_4: "",
    doc_cert_amount_4: 0,
    doc_cert_bu_5: 0,
    name_doc_cert_bu_5: "",
    doc_cert_bu_other_5: "",
    doc_cert_bu_expire_5: "",
    doc_cert_amount_5: 0,
    req_doc_idcard_house: "",
    doc_idcard_type: "",
    doc_idcard_name_1: "",
    doc_idcard_amount_1: 0,
    doc_idcard_name_2: "",
    doc_idcard_amount_2: 0,
    doc_idcard_name_3: "",
    doc_idcard_amount_3: 0,
    doc_idcard_name_4: "",
    doc_idcard_amount_4: 0,
    doc_idcard_name_5: "",
    doc_idcard_amount_5: 0,
    doc_idcard_house_type: "",
    doc_idcard_house_name_1: "",
    doc_idcard_house_amount_1: 0,
    doc_idcard_house_name_2: "",
    doc_idcard_house_amount_2: 0,
    doc_idcard_house_name_3: "",
    doc_idcard_house_amount_3: 0,
    doc_idcard_house_name_4: "",
    doc_idcard_house_amount_4: 0,
    doc_idcard_house_name_5: "",
    doc_idcard_house_amount_5: 0,
    req_doc_passport: "",
    doc_passport_name_1: "",
    doc_passport_amount_1: 0,
    doc_passport_name_2: "",
    doc_passport_amount_2: 0,
    doc_passport_name_3: "",
    doc_passport_amount_3: 0,
    doc_passport_name_4: "",
    doc_passport_amount_4: 0,
    doc_passport_name_5: "",
    doc_passport_amount_5: 0,
    req_doc_shareholders: "",
    doc_shareholders_bu_1: 0,
    name_doc_shareholders_bu_1: "",
    doc_shareholders_bu_other_1: "",
    doc_shareholders_expire_1: "",
    doc_shareholders_amount_1: 0,
    doc_shareholders_bu_2: 0,
    name_doc_shareholders_bu_2: "",
    doc_shareholders_bu_other_2: "",
    doc_shareholders_expire_2: "",
    doc_shareholders_amount_2: 0,
    doc_shareholders_bu_3: 0,
    name_doc_shareholders_bu_3: "",
    doc_shareholders_bu_other_3: "",
    doc_shareholders_expire_3: "",
    doc_shareholders_amount_3: 0,
    doc_shareholders_bu_4: 0,
    name_doc_shareholders_bu_4: "",
    doc_shareholders_bu_other_4: "",
    doc_shareholders_expire_4: "",
    doc_shareholders_amount_4: 0,
    doc_shareholders_bu_5: 0,
    name_doc_shareholders_bu_5: "",
    doc_shareholders_bu_other_5: "",
    doc_shareholders_expire_5: "",
    doc_shareholders_amount_5: 0,
    req_doc_tax: "",
    doc_tax_head_ofiice_type: "",
    doc_tax_head_office_amount: 0,
    doc_tax_branch_type: "",
    doc_tax_branch_name_1: "",
    doc_tax_branch_amount_1: 0,
    doc_tax_branch_name_2: "",
    doc_tax_branch_amount_2: 0,
    doc_tax_branch_name_3: "",
    doc_tax_branch_amount_3: 0,
    doc_tax_branch_name_4: "",
    doc_tax_branch_amount_4: 0,
    doc_tax_branch_name_5: "",
    doc_tax_branch_amount_5: 0,
    req_doc_other: "",
    doc_other_name_1: "",
    doc_other_expire_1: "",
    doc_other_amount_1: 0,
    doc_other_reason_1: "",
    doc_other_name_2: "",
    doc_other_expire_2: "",
    doc_other_amount_2: 0,
    doc_other_reason_2: "",
    doc_other_name_3: "",
    doc_other_expire_3: "",
    doc_other_amount_3: 0,
    doc_other_reason_3: "",
    doc_other_name_4: "",
    doc_other_expire_4: "",
    doc_other_amount_4: 0,
    doc_other_reason_4: "",
    doc_other_name_5: "",
    doc_other_expire_5: "",
    doc_other_amount_5: 0,
    doc_other_reason_5: "",
    doc_other_name_6: "",
    doc_other_expire_6: "",
    doc_other_amount_6: 0,
    doc_other_reason_6: "",
    doc_other_name_7: "",
    doc_other_expire_7: "",
    doc_other_amount_7: 0,
    doc_other_reason_7: "",
    doc_other_name_8: "",
    doc_other_expire_8: "",
    doc_other_amount_8: 0,
    doc_other_reason_8: "",
    doc_other_name_9: "",
    doc_other_expire_9: "",
    doc_other_amount_9: 0,
    doc_other_reason_9: "",
    doc_other_name_10: "",
    doc_other_expire_10: "",
    doc_other_amount_10: 0,
    doc_other_reason_10: "",
    for_use: "",
    for_use_doc: "",
    certified_true_copy: "",
    reason_more_one_copy: "",
    user_comment:"",
    require_handled_by: "",
    approve_request_by: "",
    create_request_by: "",
    approver_comment: "",
}

const modelFormDbd = {
    id: 0,
    id_request: "",
    id_request_type: "",
    id_sub_request_type: "",
    id_sub_division_request_type: "",
    name_th_request_type: "",
    name_en_request_type: "",
    name_th_sub_request_type: "",
    name_en_sub_request_type: "",
    name_th_division_sub_request_type: "",
    name_en_division_sub_request_type: "",
    business_unit_other: "",
    iccap_regiscap_amount: "",
    iccap_regiscap_commonstock: "",
    iccap_regiscap_preferredstock: "",
    iccap_regiscap_valuepershare: "",
    iccap_addcap_amount: "",
    iccap_addcap_commonstock: "",
    iccap_addcap_preferredstock: "",
    iccap_addcap_valuepershare: "",
    iccap_newcap_amount: "",
    iccap_newcap_stock: "",
    iccap_newcap_valuepershare: "",
    iccap_paymentpershare: "",
    iccap_paymentdate: "",
    iccap_bank_account: "",
    iccap_bank_name: "",
    iccap_bank_no: "",
    iccap_bank_branch: "",
    iccap_acknowledged: "",
    dccap_regiscap_amount: "",
    dccap_regiscap_commonstock: "",
    dccap_regiscap_preferredstock: "",
    dccap_regiscap_valuepershare: "",
    dccap_reducap_amount: "",
    dccap_reducap_type: "",
    dccap_reducap_commonstock: "",
    dccap_reducap_preferredstock: "",
    dccap_reducap_valuepershare: "",
    dccap_newcap_amount: "",
    dccap_newcap_commonstock: "",
    dccap_newcap_preferredstock: "",
    dccap_newcap_valuepershare: "",
    dccap_after_reducap: "",
    edit_name_th: "",
    edit_name_en: "",
    edit_seal_ink: "",
    edit_seal: "",
    headoffice_clocation: "",
    headoffice_nlocation_th: "",
    headoffice_nlocation_en: "",
    headoffice_file: "",
    branchoffice_ic_select: "",
    branchoffice_ic_location_1: "",
    branchoffice_ic_tel_1: "",
    branchoffice_ic_email_1: "",
    branchoffice_ic_fax_1: "",
    branchoffice_ic_file_1: "",
    branchoffice_ic_location_2: "",
    branchoffice_ic_tel_2: "",
    branchoffice_ic_email_2: "",
    branchoffice_ic_fax_2: "",
    branchoffice_ic_file_2: "",
    branchoffice_ic_location_3: "",
    branchoffice_ic_tel_3: "",
    branchoffice_ic_email_3: "",
    branchoffice_ic_fax_3: "",
    branchoffice_ic_file_3: "",
    branchoffice_ic_location_4: "",
    branchoffice_ic_tel_4: "",
    branchoffice_ic_email_4: "",
    branchoffice_ic_fax_4: "",
    branchoffice_ic_file_4: "",
    branchoffice_ic_location_5: "",
    branchoffice_ic_tel_5: "",
    branchoffice_ic_email_5: "",
    branchoffice_ic_fax_5: "",
    branchoffice_ic_file_5: "",
    branchoffice_dc_select: "",
    branchoffice_dc_location_1: "",
    branchoffice_dc_location_2: "",
    branchoffice_dc_location_3: "",
    branchoffice_dc_location_4: "",
    branchoffice_dc_location_5: "",
    branchoffice_edit_select: "",
    branchoffice_edit_clocation_1: "",
    branchoffice_edit_nlocation_1: "",
    branchoffice_edit_clocation_2: "",
    branchoffice_edit_nlocation_2: "",
    branchoffice_edit_clocation_3: "",
    branchoffice_edit_nlocation_3: "",
    branchoffice_edit_clocation_4: "",
    branchoffice_edit_nlocation_4: "",
    branchoffice_edit_clocation_5: "",
    branchoffice_edit_nlocation_5: "",
    objective_add_select: "",
    objective_add_file: "",
    objective_add_other: "",
    objective_edit_select: "",
    objective_edit_file: "",
    objective_edit_other: "",
    objective_main_select: "",
    objective_main_other: "",
    bylaws_add_select: "",
    bylaws_add_file: "",
    bylaws_edit_select: "",
    bylaws_edit_file: "",
    cod_out_select: "",
    cod_out_name_1: "",
    cod_out_name_en_1: "",
    cod_out_name_2: "",
    cod_out_name_en_2: "",
    cod_out_name_3: "",
    cod_out_name_en_3: "",
    cod_out_name_4: "",
    cod_out_name_en_4: "",
    cod_out_name_5: "",
    cod_out_name_en_5: "",
    cod_out_name_6: "",
    cod_out_name_en_6: "",
    cod_out_name_7: "",
    cod_out_name_en_7: "",
    cod_out_name_8: "",
    cod_out_name_en_8: "",
    cod_out_name_9: "",
    cod_out_name_en_9: "",
    cod_out_name_10: "",
    cod_out_name_en_10: "",
    cod_add_select: "",
    cod_add_name_1: "",
    cod_add_name_en_1: "",
    cod_add_tel_1: "",
    cod_add_email_1: "",
    cod_add_file_1: "",
    cod_add_name_2: "",
    cod_add_name_en_2: "",
    cod_add_tel_2: "",
    cod_add_email_2: "",
    cod_add_file_2: "",
    cod_add_name_3: "",
    cod_add_name_en_3: "",
    cod_add_tel_3: "",
    cod_add_email_3: "",
    cod_add_file_3: "",
    cod_add_name_4: "",
    cod_add_name_en_4: "",
    cod_add_tel_4: "",
    cod_add_email_4: "",
    cod_add_file_4: "",
    cod_add_name_5: "",
    cod_add_name_en_5: "",
    cod_add_tel_5: "",
    cod_add_email_5: "",
    cod_add_file_5: "",
    cod_add_name_6: "",
    cod_add_name_en_6: "",
    cod_add_tel_6: "",
    cod_add_email_6: "",
    cod_add_file_6: "",
    cod_add_name_7: "",
    cod_add_name_en_7: "",
    cod_add_tel_7: "",
    cod_add_email_7: "",
    cod_add_file_7: "",
    cod_add_name_8: "",
    cod_add_name_en_8: "",
    cod_add_tel_8: "",
    cod_add_email_8: "",
    cod_add_file_8: "",
    cod_add_name_9: "",
    cod_add_name_en_9: "",
    cod_add_tel_9: "",
    cod_add_email_9: "",
    cod_add_file_9: "",
    cod_add_name_10: "",
    cod_add_name_en_10: "",
    cod_add_tel_10: "",
    cod_add_email_10: "",
    cod_add_file_10: "",
    cod_current_powerofdirector: "",
    cod_new_powerofdirector: "",
    cod_remark: "",
    coa_share_bath: "",
    coa_share_number: "",
    coa_share_addition: "",
    coa_share_total: "",
    coa_share_date: "",
    ts_ctp_transferor_1: "",
    ts_ctp_transferee_1: "",
    ts_ctp_amountshare_1: "",
    ts_ctp_pershare_1: 0,
    ts_ctp_totalshare_1: "",
    ts_ctp_paydate_1: "",
    ts_ctp_file_1: "",
    ts_ctp_transferor_2: "",
    ts_ctp_transferee_2: "",
    ts_ctp_amountshare_2: "",
    ts_ctp_pershare_2: 0,
    ts_ctp_totalshare_2: "",
    ts_ctp_paydate_2: "",
    ts_ctp_file_2: "",
    ts_ctp_transferor_3: "",
    ts_ctp_transferee_3: "",
    ts_ctp_amountshare_3: "",
    ts_ctp_pershare_3: 0,
    ts_ctp_totalshare_3: "",
    ts_ctp_paydate_3: "",
    ts_ctp_file_3: "",
    ts_ctp_transferor_4: "",
    ts_ctp_transferee_4: "",
    ts_ctp_amountshare_4: "",
    ts_ctp_pershare_4: 0,
    ts_ctp_totalshare_4: "",
    ts_ctp_paydate_4: "",
    ts_ctp_file_4: "",
    ts_ctp_transferor_5: "",
    ts_ctp_transferee_5: "",
    ts_ctp_amountshare_5: "",
    ts_ctp_pershare_5: 0,
    ts_ctp_totalshare_5: "",
    ts_ctp_paydate_5: "",
    ts_ctp_file_5: "",
    dtc_liquidator_1: "",
    dtc_liquidator_2: "",
    dtc_liquidator_3: "",
    dtc_liquidator_4: "",
    dtc_liquidator_5: "",
    dtc_powerofliquidator: "",
    dtc_liquidatoroffice_name: "",
    dtc_liquidatoroffice_file: "",
    dtc_auditor_1: "",
    dtc_auditor_2: "",
    dtc_auditor_3: "",
    dtc_auditor_4: "",
    dtc_auditor_5: "",
    dtc_auditoroffice: "",
    dtc_auditorfee: "",
    dtc_remark: "",
    col_balancesheet_file: "",
    col_docs_file: "",
    col_acknowledged: "",
    col_docs_ship_date: "", 
    col_docs_sent_date: "",
    other_title: "",
    other_detail: "",
    iccap_select: "",
    dccap_select: "",
    edit_name_select: "",
    edit_seal_select: "",
    headoffice_select: "",
    branchoffice_select: "",
    objective_select: "",
    bylaws_select: "",
    cod_select: "",
    coa_select: "",
    ts_select: "",
    dtc_select: "",
    col_select: "",
    other_select: "",
    id_confidential_level: 0,
}

const modelFormPam = {
    id: 0,
    id_request: "",
    id_request_type: "",
    id_sub_request_type: "",
    id_sub_division_request_type: "",
    project_name: "",
    req_legal_team_to: "",
    req_legal_team_to_doc: "",
    id_business_unit: "",
    business_unit_other: "",
    business_unit_act_as: "",
    counterparty_name: "",
    counterparty_act_as: "",
    purpose_sale: "",
    place_of_delivery: "",
    detail_product: "",
    detail_product_doc: "",
    sow_deliver: "",
    sale_detail_doc: "",
    term_start_date: "",
    term_end_date: "",
    practical_complete_date: "",
    final_complete_date: "",
    product_price: "",
    installation_fee: "",
    total_product_price_includevat: "",
    total_product_price_excludevat: "",
    is_stamp_duty: "",
    stamp_duty_price: "",
    payment_term_type: "",
    payment_term_detail: "",
    credit_term: "",
    deposit_type: "",
    deposit_detail: "",
    performance_bond: "",
    retention: "",
    return_of_retention: "",
    deposit_bond: "",
    recoupment: "",
    daily_penalty_rate: "",
    manage_penalty_rate: "",
    other_penalty: "",
    ot_penalty_rate: "",
    terminate_penalty: "",
    acquired_buyer: "",
    acquired_seller: "",
    warranty: "",
    id_language: 0,
    share_pdpa: "",
    user_comment: "",
    id_confidential_level: 0
}

const modeFormPoa = {
    id: 0,
    id_request: 0,
    id_request_type: 0,
    id_sub_request_type: 0,
    id_sub_division_request_type: 0,
    purpose_poa: "",
    purpose_poa_doc: "",
    date_poa: "",
    date_poa_reason: "",
    id_business_unit: 0,
    business_unit_other: "",
    grantor: "",
    attorney: "",
    attorney_doc: "",
    attorney_number_condition: "",
    detail_poa: "",
    detail_poa_doc: "",
    duration_poa_type: "",
    duration_poa_start_date: "",
    duration_poa_end_date: "",
    duration_poa_reason: "",
    witness: "",
    form_other_poa: "",
    form_other_poa_doc: "",
    other_support_doc: "",
    company_affidavit_type: "",
    company_affidavit_age: "",
    company_affidavit_reason: "",
    req_idcard_houseregis_type: "",
    req_idcard_houseregis_amount: "",
    req_idcard_houseregis_reason: "",
    other_info: "",
    require_handled_by: "",
    approve_request_by: "",
    approver_comment: "",
    create_request_by: "",
    check_request_no: "",
    check_user_email: "",
};

const modeFormGct = {
    id: 0,
    id_request: "",
    id_request_type: "",
    id_sub_request_type: "",
    id_sub_division_request_type: "",
    name_th_request_type: "",
    name_en_request_type: "",
    name_th_sub_request_type: "",
    name_en_sub_request_type: "",
    name_th_division_sub_request_type: "",
    name_en_division_sub_request_type: "",
    project_name: "",
	req_legal_team_to: "",               
	req_legal_team_to_doc: "",
	id_business_unit: "",
	business_unit_other: "",
	business_unit_act_as: "",
	counterparty_name: "",
	counterparty_doc: "",
	counterparty_act_as: "",
	purpose: "",
	place_of_performance: "",
	responsibilities_each_party: "",
	detail_contract_doc: "",
	term_start_date: "",
	term_end_date: "",
	renewal_term: "",
	rate_of_price: "",
	payment_term: "",
	payment_term_desc_lump_sum: "",
	payment_term_desc_instalment: "",
	penalty: "",
	termination: "",
	is_stamp_duty: "",
	stamp_duty_price: "",
	other_fee: "",
	other_special_clause: "", //int
	id_language: "", //int
	share_pdpa: "", 
	id_confidential_level: "", //int
	user_comment: "",
	approver_comment: "",
    require_handled_by: "",
    approve_request_by: "",
    approver_comment: "",
    create_request_by: "",
    check_request_no: "",
    check_user_email: "",
};

export { modelDataRequest, modelRequestWorkFlow, modelSendMail, modelFormCsa, modelFormNda, modelFormLdr, modelFormDbd, modeFormPoa, modelFormPam, modeFormGct}